import { DateTime } from 'luxon';
import { AdminParsers } from '../admin/admin-parsers';
import {
  PurchaseOrder,
  PurchaseOrderLineItem,
  PurchaseOrderPaymentMethod,
  PurchaseOrderProductLineItem,
  PurchaseOrderStatus,
} from './purchase-order';
import { VendorParsers } from '../vendor/vendor-parsers';

export namespace PurchaseOrderParsers {
  export class PurchaseOrderJson {
    id!: string;
    locationId!: number;
    vendor!: VendorParsers.VendorJson;
    products!: PurchaseOrderProductLineItem[];
    lineItems!: PurchaseOrderLineItem[];
    purchasedBy!: AdminParsers.AdminJson;
    purchasedAt!: string;
    paymentMethodId?: PurchaseOrderPaymentMethod;
    subtotal!: number;
    status!: PurchaseOrderStatus;
    createdAt!: string;
    updatedAt!: string;
  }

  export function toPurchaseOrder(input: PurchaseOrderJson): PurchaseOrder {
    return {
      ...input,
      vendor: VendorParsers.toVendor(input.vendor),
      purchasedBy: AdminParsers.toAdmin(input.purchasedBy),
      purchasedAt: DateTime.fromISO(input.purchasedAt, { setZone: true }),
      createdAt: DateTime.fromISO(input.createdAt, { setZone: true }),
      updatedAt: DateTime.fromISO(input.updatedAt, { setZone: true }),
    };
  }
}
